import { useCallback } from 'react';
import { getPaymentMethodById } from '@atlassian/temp-proxies';
import { autoRetry } from '../../../auto-retry/src/auto-retry';

export const usePollPaymentMethod = () => {
  const pollPaymentMethod = useCallback(
    async ({ txaId, paymentMethodId }: { txaId: string; paymentMethodId: string }) => {
      return new Promise((resolve, reject) => {
        autoRetry({
          call: async () => {
            const response = await getPaymentMethodById(paymentMethodId, txaId);
            return response;
          },
          initialTimer: 1000,
          maxTimer: 60000,
          shouldRetry: (response) => {
            return response?.id === null;
          },
          onComplete: (response) => {
            resolve(response);
          },
          numberOfTries: 5,
          backoffFactor: 2,
          onFailure: () => {
            reject(new Error(`Max retries reached. Try again or Contact Partner Service Desk`));
          },
        });
      });
    },
    []
  );

  return { pollPaymentMethod };
};
